import { PushNotificationRequest } from '@/models/PushNotificationRequest';
import { action } from 'typesafe-actions';
import { PushNotification, PushNotificationTypes } from './types';

export const getPushNotificationListRequest = (data: PushNotificationRequest) =>
    action(PushNotificationTypes.GET_PUSH_NOTIFICATION_LIST_REQUEST, data);
export const allPushNotificationListSuccess = (data: PushNotification[], total: number) =>
    action(PushNotificationTypes.ALL_PUSH_NOTIFICATION_LIST_SUCCESS, { data, total });
export const uncheckedPushNotificationListSuccess = (data: PushNotification[], total: number) =>
    action(PushNotificationTypes.UNCHECKED_PUSH_NOTIFICATION_LIST_SUCCESS, { data, total });
export const getPushNotificationListFailure = () => action(PushNotificationTypes.GET_PUSH_NOTIFICATION_LIST_FAILURE);

export const updatePushNotificationStatusRequest = (notificationId: number) =>
    action(PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS, notificationId);
export const updatePushNotificationStatusSuccess = (notificationId: number) =>
    action(PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS_SUCCESS, notificationId);
export const updatePushNotificationStatusFailure = () => action(PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS_FAILURE);

export const clearUncheckedNotifications = () => action(PushNotificationTypes.CLEAR_UNCHECKED_NOTIFICATIONS);
export const clearAllNotifications = () => action(PushNotificationTypes.CLEAR_ALL_NOTIFICATIONS);
